<template>
    <v-btn v-if="!isGuest"
           @click="addCandidateToConversation"
           :disabled="!canCreateAssets || !image || IDT.initial"
           v-tippy
           content="Send Look to Chat"
    >
        <v-icon class="material-icons">add_comment</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        ...mapGetters('User', ['isGuest']),
    },
    methods: {
        async addCandidateToConversation() {
            this.$store.dispatch('UI/setRightColumn', 'comments')
            this.$store.dispatch("Comments/uploadingAssetLoader", true);

            let newCandidateName = this.$store.getters["Projects/newAutoCandidateName"];

            this.$root.commentsEditor.quill.focus();
            this.$root.commentsEditor.$parent.positionCursorAtEnd();

            let candidates = await lutify.addCandidate(newCandidateName);
            let denotationChar = "$";
            let list = this.$store.getters["Comments/hashValues"]('candidate');

            this.$store.dispatch("Comments/uploadingAssetLoader", false);

            candidates.forEach(candidate => {
                let mention = list.find(value => value.id == candidate.data.id);
                vm.$root.commentsEditor.$parent.insertMention(denotationChar, mention, true);
            })
        }
    }
}
</script>